import { UserStopSapPaymentTable } from './UserStopSapPaymentTable'
import { withUserStopSapPaymentTable } from './withUserStopSapPaymentTable'

const ConnectedUserStopSapPaymentTable = withUserStopSapPaymentTable(
  UserStopSapPaymentTable
)
export { ConnectedUserStopSapPaymentTable as UserStopSapPaymentTable }
